import React from "react";
import { SignOut } from "aws-amplify-react";

export default class CustomSignOut extends SignOut {

  handleSignOut = () => super.signOut();

  render() {
    return (
      <div onClick={this.handleSignOut}>{this.props.children}</div>
    )
  }
}
